import { FieldValidator,fieldValidation } from "../config/types";

/**
 * Validates a password based on the following criteria:
 * - At least 8 characters long
 * - Contains at least one uppercase letter
 * - Contains at least one lowercase letter
 * - Contains at least one number
 *
 * @param password - The password to validate
 * @returns A boolean indicating if the password is valid and an optional error message
 */
export function validatePassword(password: string): { isValid: boolean; errorMessage?: string } {
    const lengthRequirement = /.{8,}/;
    const uppercaseRequirement = /[A-Z]/;
    const lowercaseRequirement = /[a-z]/;
    const numberRequirement = /[0-9]/;
  
    if (!lengthRequirement.test(password)) {
      return { isValid: false, errorMessage: 'Password must be at least 8 characters long.' };
    }
    if (!uppercaseRequirement.test(password)) {
      return { isValid: false, errorMessage: 'Password must contain at least one uppercase letter.' };
    }
    if (!lowercaseRequirement.test(password)) {
      return { isValid: false, errorMessage: 'Password must contain at least one lowercase letter.' };
    }
    if (!numberRequirement.test(password)) {
      return { isValid: false, errorMessage: 'Password must contain at least one number.' };
    }
  
    return { isValid: true };
  }



  export function isFormFilled<T extends Record<string, any>>(
    form: T, 
    requiredFields?: (keyof T)[], 
    excludeFields?: (keyof T)[]  
  ): boolean {
    return Object.entries(form).every(([field, data]):boolean => {
      const fieldKey = field as keyof T;
      const value =  typeof data.value === "string" ? data.value.trim() : data.value
      const isValid=data.isValid !==undefined ?data.isValid: true;
      const check=value !== "" && isValid;
      if (excludeFields && excludeFields.includes(fieldKey)) {
        return true;
      }

      if (requiredFields && requiredFields.includes(fieldKey)) {
        return check
      }
  
      return check
    });
  }
  
  /**
 * Validates an email address based on standard criteria.
 *
 * @param email - The email address to validate
 * @returns A boolean indicating if the email is valid and an optional error message
 */
export function validateEmail(email: string): { isValid: boolean; errorMessage?: string } {
  const emailRequirement = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRequirement.test(email)) {
    return { isValid: false, errorMessage: 'Invalid email format.' };
  }

  return { isValid: true };
}



export function validateNumber(value: string): { isValid: boolean; errorMessage?: string } {
  const numberRequirement = /^[0-9]+(\.[0-9]+)?$/;

  if (!numberRequirement.test(value.trim())) {
    return { isValid: false, errorMessage: 'Value must be a valid number.' };
  }

  return { isValid: true };
}

export function validateString(value: string): { isValid: boolean; errorMessage?: string } {
  if (typeof value !== 'string' || ( typeof value == 'string'  && value.trim() === '')) {
    return { isValid: false, errorMessage: 'Value must be a non-empty string.' };
  }

  return { isValid: true };
}

export function validateBoolean(value: boolean): { isValid: boolean; errorMessage?: string } {
  if (typeof value !== 'boolean') {
    return { isValid: false, errorMessage: 'Value must be a boolean.' };
  }

  return { isValid: true };
}
function validateTelephone(phoneNumber: string): { isValid: boolean; errorMessage?: string } {
   const phoneRegex = /^\(\d{3}\)\d{6,11}$/;

  if (phoneRegex.test(phoneNumber)) {
    return { isValid: true ,errorMessage:''}; 
  }

  return { 
    isValid: false, 
    errorMessage: "Invalid phone number format. Expected format is .(XXX)XXXXXXXX"
  };
}

export function validateField<T>(input: T, fieldType: FieldValidator="string"): { isValid: boolean; errorMessage?: string } {
  switch (fieldType) {
    case fieldValidation.EMIAL:
      return validateEmail(input as string);
    case fieldValidation.NUMBER:
      return validateNumber(input as string);
    case fieldValidation.PASSWORD:
      return validatePassword(input as string);
    case fieldValidation.STRING:
      return validateString(input as string);
    case fieldValidation.BOOLEAN:
      return validateBoolean(input as boolean);
    case fieldValidation.TELEPHONE:
      return validateTelephone(input as string);
    case fieldValidation.NONE:
        return {isValid:true};
    default:
      return validateString(input as string);
  }
}